import "./MesseApp.scss"
import * as React from "react";
import {AppMainStates, Config} from "../../app/models/Constants";
import OverviewScreenContainer from "./overviewScreen/OverviewScreenContainer";
import {ErrorsAndWarnings} from "./global/ErrorsAndWarnings";
import LoadingScreenContainer from "./loadingScreen/LoadingScreenContainer";
import {TweenMax} from "gsap/TweenMax";

export interface MesseAppProps {
    mainState: string;
    lastMainState: string;
}

export class MesseApp extends React.Component<MesseAppProps, {}> {
    state: any = {
        hasLoadError: false,
        loadErrorMessage: '',
    };

    componentDidMount(): void {
        //this.resizeHandler();
        //addEventListener("resize", this.resizeHandler);
    }

    protected resizeHandler = (evt: any = null) => {
        const container: Element = document.getElementsByClassName("MesseApp")[0];
        const PARENT_WIDTH: number = container.clientWidth;
        const PARENT_HEIGHT: number = container.clientHeight;
        const SCALE_X: number = PARENT_WIDTH / Config.APP_WIDTH;
        const SCALE_Y: number = PARENT_HEIGHT / Config.APP_HEIGHT;
        const SCALE: number = Math.min(SCALE_X, SCALE_Y);
        const X: number = -Config.APP_WIDTH * .5;
        const Y: number = -Config.APP_HEIGHT * .5;


        TweenMax.set(".MesseApp .scaleContainer", {
            x: X,
            y: Y,
            width: Config.APP_WIDTH,
            height: Config.APP_HEIGHT,
            scale: SCALE
        });
        /*
                        TweenMax.set(".MesseApp .scaleContainer", {
                            x: X*1,
                            y: Y*1,
                            width: Config.APP_WIDTH,
                            height: Config.APP_HEIGHT,
                            scale: 1
                        });
                        /**/
    };

    render() {
        let currentScreen: JSX.Element;
        let lastScreen: JSX.Element;

        switch (this.props.mainState) {
            case AppMainStates.OVERVIEW:
                currentScreen = <OverviewScreenContainer key={AppMainStates.OVERVIEW}/>;
                break;
            default:
                currentScreen = <LoadingScreenContainer key={AppMainStates.LOADING}/>;
        }

        switch (this.props.lastMainState) {
            case AppMainStates.OVERVIEW:
                lastScreen = <OverviewScreenContainer key={AppMainStates.OVERVIEW}/>;
                break;
            case AppMainStates.LOADING:
                lastScreen = <LoadingScreenContainer key={AppMainStates.LOADING}/>;
                break;
        }

        if (this.state.hasLoadError) {
            currentScreen = ErrorsAndWarnings.displayError(
                'Load error:',
                [<p>{this.state.loadErrorMessage}</p>]
            )
        }
        return <div className='MesseApp'>
            {currentScreen}
            {lastScreen}
        </div>
    }
}
